// @ts-nocheck
'use-script'
/**
 * menu() returns menu json the order
 * @param <String> tag
 * @return <Element> element
 */
const Menu = [{

        title: "Dashboard",
        action: "home",
        group: 'dashboard',
        items: [{
                path: "dashboard/dashboard1",
                title: "Dashboard1",

            }, {
                path: "dashboard/dashboard2",
                title: "Dashboard2",

            },

        ]
    }, {
        title: 'Trader',
        action: 'account_balance_wallet',
        group: 'trader',
        items: [{
            path: 'trader/exchange',
            title: 'Exchange'
        }, {
            path: 'trader/market',
            title: 'Market'
        }, {
            path: 'trader/portfolio',
            title: 'Portfolio'
        }, {
            path: 'trader/transactions',
            title: 'Transactions'
        }]
    }, {
        header: "Aplications",
        group: 'profile',
        title: "Users",
        action: "contacts",
        items: [  {
                path: "users/contact",
                title: "Contact ",

            }, 
            {
                path: "users/profile",
                title: "Profile",

            }, {
                path: "users/projects",
                title: "Projects",

            }, {
                path: "users/settings",
                title: "Settings",

            }, {
                path: "users/video-call",
                title: "Video Call",

            },



        ],

    },
    {

        header: "Aplications",
        group: 'apps',
        title: "Apps",
        action: "dashboard",
        items: [{
            path: "apps/calendar",
            title: "Calendar",

        }, {
            path: "apps/file-manager",
            title: "Files Manager",

        },{
            path: "apps/inbox",
            title: "Email Inbox",

        }, {
                path: "apps/draggable",
                title: "Draggable",

            }, {
                path: "apps/invoice",
                title: "Invoice",

            },{
                path: "apps/loading",
                title: "Loading",

            }, {
                path: "apps/pricing",
                title: "Pricing",

            },   {
                path: "apps/sweet-alert",
                title: "Sweet Alert ",

            }, {
                path: "apps/timeline",
                title: "Timeline",

            },
            {
                path: "apps/todo-list",
                title: "TodoList",

            },


        ],
    },{
        title: "Charts",
        action: " mdi-chart-bar",
        group: 'charts',
        items: [{
                path: "charts/apexcharts",
                action: "ti-cloud",
                title: "Apexcharts",
                color: "blue",

            }, {
                path: "charts/c3",
                title: "C3 Charts",
                action: "mdi-dna",

            }, {
                path: "charts/chart-js",
                action: "mdi-celtic-cross",
                title: "ChartJs",

            },


            {
                path: "charts/echarts",
                action: "mdi-celtic-cross",
                title: "Echarts",

            },

            {
                path: "charts/morris",
                action: "mdi-celtic-cross",
                title: "Morris Charts",

            },

            {
                path: "charts/ricksaw",
                title: "Ricksaw",
                action: "mdi-hazard-lights",

            }, 

        ],
    }, {
        title: "Widgets",
        action: "brightness_7",
        group: 'widgets',
        items: [{
                path: "widgets/widget-charts",
                title: "Widget Charts",

            },
            {
                path: "widgets/widget-list",
                title: "Widget List",


            }
        ]
    },  {
        title: "Elements",
        group: 'elements',
        action: "apps",
        items: [{
                path: "ui/alert",
                title: "Alert",

            },

            {
                path: "ui/buttons",
                title: "Buttons",
                action: "opacity",

            },


            {
                path: "ui/cards",
                title: "Cards",
                action: "motorcycle",

            }, {
                path: "ui/chips",
                title: "Chips",
                action: "motorcycle",

            }, {
                path: "ui/carousels",
                title: "Carousels",
                action: "pets",

            },

            {
                path: "ui/hover",
                title: "Hover",
                action: "backup",

            }, {
                path: "ui/images",
                title: "Images",
                action: "backup",

            }, {
                path: "ui/list",
                title: "List",
                action: "backup",

            },
            {
                path: "ui/parallax",
                title: "Parallax",

            },
         
            {
                path: "ui/progressbar",
                title: "Progressbar",


            }, {
                path: "ui/steppers",
                title: "Steppers",


            },
            {
                path: "ui/tabs",
                title: "Tabs",


            }, {
                path: "ui/tooltip",
                title: "Tooltip",
                action: "pets",

            },

            {
                path: "ui/typography",
                title: "Typography",
                action: "watch_later",

            },
        ]
    },  {
        title: "Tables",
        action: "mdi-table",
        group: 'tables',
        items: [{
                path: "tables/table-simple",
                title: "Simple",

            },
            {
                path: "tables/table-datatable",
                title: "Datatable",


            }, {
                path: "tables/data-iterators",
                title: "Data Iterators",


            }
        ]
    }, {
        title: "Pages",
        action: "create_new_folder",
        group: 'pages1',
        items: [{

                title: "Page Blank",
                path: "pages/page-empty",

            }, {

                title: "Faq",
                path: "pages/page-faq",

            }, {

                title: "Login",
                path: "pages/page-login",

            },


            {

                title: "Register",
                path: "pages/page-register",

            }, {

                title: "Error 404",
                path: "pages/page-error",

            },

        ]
    },




]


export default Menu